import { Controller, type Control } from 'react-hook-form';
import { DatePicker, Label, Select } from '@shared/components';
import type { ConfigureAddOnsFormData } from '../../../schemas/ConfigureAddOnsSchema';

interface AddOnScheduleFormProps {
    id: string;
    addOnId: string;
    addOnName: string;
    control: Control<ConfigureAddOnsFormData>;
    linkedServiceId: string;
    options: { value: string; label: string }[];
}

export function AddOnScheduleForm({
    id,
    addOnId,
    addOnName,
    control,
    linkedServiceId,
    options,
}: AddOnScheduleFormProps) {
    const scheduleId = `addon-${addOnId}-schedule`;
    const dateId = `addon-${addOnId}-date`;

    return (
        <div
            id={id}
            role="group"
            aria-label={`Schedule ${addOnName}`}
            className="mt-4 grid grid-cols-1 gap-3 border-t border-mp-border pt-4 sm:grid-cols-2"
        >
            <div>
                <Label htmlFor={scheduleId}>Schedule Type</Label>
                <Controller
                    name="linkedServiceId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Select
                            id={scheduleId}
                            ariaLabel={`Schedule for ${addOnName}`}
                            options={options}
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            error={!!error}
                            hint={error?.message}
                        />
                    )}
                />
            </div>
            {linkedServiceId === 'independent' && (
                <div>
                    <Label htmlFor={dateId}>Scheduled Date</Label>
                    <Controller
                        name="addOnDate"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                            <DatePicker
                                id={dateId}
                                ariaLabel={`Scheduled date for ${addOnName}`}
                                value={field.value ?? null}
                                onChange={field.onChange}
                                error={!!error}
                                hint={error?.message}
                            />
                        )}
                    />
                </div>
            )}
        </div>
    );
}
